<template>
  <div>
    <v-btn
      id="chat-button"
      color="rgb(255, 149, 24)"
      dark
      fixed
      bottom
      right
      fab
      x-large
      link
      :style="currentlyViewedChallenge.isFacilitator || currentlyViewedChallenge.isCofacilitator ? 'bottom: 1em; right: 120px' : 'bottom: 1em; right: 20px'"
      @click="handleToggleChatMenu"
    >
      <v-badge
        color="red"
        overlap
        bordered
        :value="unseenChats !== 0"
        light
      >
        <template
          v-slot:badge
        >
          <span>{{ unseenChats }}</span>
        </template>
        <v-icon>mdi-message-reply-text</v-icon>
      </v-badge>
    </v-btn>
    <ChatLog :chatMenuIsOpen="chatMenuIsOpen" @toggleMenu="handleToggleChatMenu"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import ChatLog from './ChatLog'

export default {
  name: 'ChatFAB',

  components: {
    ChatLog
  },

  data: () => ({
    chatMenuIsOpen: false,
    unseenChats: 0
  }),

  computed: {
    ...mapState({
      chatLog: state => state.event.chatLog,
      currentlyViewedChallenge: state => state.challenge.currentlyViewedChallenge
    })
  },

  watch: {
    chatLog () {
      if (this.chatLog.length > 0 && !this.chatMenuIsOpen) {
        console.log('chat closing')
        this.unseenChats++
      }
    }
  },

  methods: {
    handleToggleChatMenu () {
      this.chatMenuIsOpen = !this.chatMenuIsOpen
      if (this.chatMenuIsOpen) {
        this.unseenChats = 0
      }
    }
  }
}
</script>
